<template>
    <div style="display: flex; flex-direction: column; background-color: rgba(0, 0, 0, 0.7);">
        <div style="display: flex; justify-content: center; position: relative; align-items: center; margin-top: 20px;">
            <!-- <div style="text-shadow: 0px 2px 10px #210F03; color: transparent; font-weight: 700;">만들기</div> -->
            <div @click="closeFeed" style="position: absolute; top: 50%; transform: translateY(-50%); top: 20px; right: 12px;">
                <img style="width: 40px;" :src="require('@/assets/img/circle_x_btn.png')" alt="">
            </div>
        </div>
        <div style="margin-top: 53px; color: #fff;">
            <div class="title">어떤 입단 요청서를 작성할까요?</div>
            <div class="sub_title">좌우로 슬라이드하여 선택해 주세요</div>
            <swiper @slideChange="onSlideChange($event)" style="border-radius: 12px; padding-bottom: 82px; overflow: hidden; " :options="swiperOption" role="tablist" ref="swiper">
                <swiper-slide class="slide-card">
                    <div class="card">
                        <!-- <div style="position: absolute; top: 0; z-index: 3; right: 0;">
                            <img :src="require('@/assets/img/arrow_gray_new.png')" alt="">
                        </div> -->
                        <div class="card_img">
                            <img style="width: 100%; height: 100%; object-fit: cover;" :src="require('@/assets/img/common_request_back.png')" alt="">
                        </div>
                        <div class="card_contents">
                            <div style="background-color: #009dff;" class="card_theme">축구선수가 되고 싶다면</div>
                            <div class="card_title">일반 입단 요청서</div>
                            <div class="card_text">나의 강점을 요청서로 작성하여<br>
                                전국의 수많은 구단과 스카우터들의<br>
                                입단 제안을 폭넓게 받아보세요</div>
                        </div>
                    </div>
                </swiper-slide>
                <swiper-slide class="slide-card">
                    <div class="card">
                        <div class="un_active_overlay">
                            <img style="width: 80px;" :src="require('@/assets/img/lock_icon.png')" alt="">
                            <div style="margin-top: 10px; color: #fff; font-weight: 700; line-height: 24px;">서비스 준비중입니다</div>
                        </div>
                        <div class="card_img">
                            <img style="width: 100%; height: 100%; object-fit: cover;" :src="require('@/assets/img/secret_request_back.png')" alt="">
                        </div>
                        <div class="card_contents">
                            <div style="background-color: #A855F7;" class="card_theme">실명과 소속을 철저히 비밀</div>
                            <div class="card_title">시크릿 에이전트</div>
                            <div class="card_text">이적 소문이 걱정되시나요?<br>
                                비공개 입단 요청서로 눈치 보지 않고,<br>
                                조용하게 입단 테스트 제안을 받아보세요.</div>
                        </div>
                    </div>
                </swiper-slide>
                <div class="swiper-pagination paging_text" slot="pagination" style="font-size:12px; bottom: 27px; height: 20px; text-align: center; z-index: 10; display:inline-block;"></div>
            </swiper>
        </div>
        <div @click="showWriteForm" class="make_feed_btn">입단 요청서 작성하기</div>
        <LearnSoccerWriteForm :beforeCompleteAction="beforeCompleteAction" :isFromPageBottom="true" :isShowWriteForm="isShowWriteForm" :closeWriteForm="closeWriteForm" :formType="writeFormType" :trainingBannerList="trainingBannerList" :selectTrainingBanner="selectTrainingBanner" :refer_idx="seletedTrainingBannerIdx"></LearnSoccerWriteForm>
        <!-- <MakeRequestJoinForm :isForce="false" :isShowMakeRequestJoinForm="isShowMakeRequestJoinForm" :closeRequestJoinForm="beforeCompleteAction"></MakeRequestJoinForm> -->
    </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import LearnSoccerWriteForm from '@/components/soccerhowmain/LearnSoccerWriteForm'
// import MakeRequestJoinForm from '@/components/soccerhowmain/MakeRequestJoinForm'
import { MAIN_TYPE } from '@/Constants'

const CUR_TYPE = {
    COMMON: 0,
    SECRET: 1
}

const FORM_TYPE = {
    TOPIC: 'TOPIC',
    SKILL: 'SKILL',
    TRAINING: 'TRAINING'
}

export default {
    name: 'MakeFeedSoccerJoin',
    components: { swiper, swiperSlide, LearnSoccerWriteForm },
    props: {
        completeAction: {
            type: Function,
            default: () => { }
        },
        trainingBannerList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            swiperOption: {
                slidesPerView: 'auto',
                centeredSlides: true,
                spaceBetween: 0,
                grabCursor: true,
                slidesOffsetBefore: 0, // slidesOffsetBefore는 첫번째 슬라이드의 시작점에 대한 변경할 때 사용
                slidesOffsetAfter: 0, // slidesOffsetAfter는 마지막 슬라이드 시작점 + 마지막 슬라이드 너비에 해당하는 위치의 변경이 필요할 때 사용
                freeMode: false, // freeMode를 사용시 스크롤하는 느낌으로 구현 가능
                centerInsufficientSlides: true, // 컨텐츠의 수량에 따라 중앙정렬 여부를 결정함
                loop: false,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets'
                },
                curIndex: 0,
            },
            feedList: [
                { contents: '궁금한 건 물어보고, 실력은 마음껏 뽐내보세요', title: '그라운드', type: 'ground' },
                { contents: '꿈을 향해! 입단 요청서로 감독님께 어필하세요!', title: '축구팀 입단', type: 'ground' },
            ],
            FORM_TYPE: FORM_TYPE,
            curType: CUR_TYPE.COMMON,
            CUR_TYPE: CUR_TYPE,
            isShowWriteForm: false,
            isShowMakeRequestJoinForm: false,
            writeFormType: FORM_TYPE.TRAINING,
            seletedTrainingBannerIdx: -1
        }
    },
    methods: {
        selectTrainingBanner(each) {
            this.seletedTrainingBannerIdx = each.idx
        },
        closeFeed() {
            this.$GlobalStore.closeLastModal()
        },
        closeRequestJoinForm() {
            this.isShowMakeRequestJoinForm = false
        },
        closeWriteForm() {
            this.seletedTrainingBannerIdx = -1
            this.isShowWriteForm = false
        },
        onSlideChange() {
            const swiper = this.$refs.swiper.swiper; // ✅ Swiper 인스턴스 직접 가져오기
            const activeIndex = swiper.activeIndex
            this.curType = activeIndex
        },
        showWriteForm() {
            if (this.curType === CUR_TYPE.COMMON) {
                this.$GlobalStore.addModal('SelectPlayerType', { requestType: this.curType })
            } else {
                this.$GlobalStore.showAlert('서비스 준비중입니다')
                return
                // this.$GlobalStore.addModal('PaymentSecretRequestForm')
            }
            // this.isShowWriteForm = true
        },
        beforeCompleteAction(isSave, soccerhowIdx) {
            if (this.curType === CUR_TYPE.COMMON) {
                this.isShowWriteForm = false
                setTimeout(() => {
                    this.$GlobalStore.addModal('TrainingRequestDetail', { main_type: MAIN_TYPE.SOCCER_LEARN, isModalBackTransparent: true, isExpert: false, soccerhowIdx: soccerhowIdx })
                    this.completeAction(isSave, soccerhowIdx)
                }, 500)
            } else {
                this.isShowWriteForm = false
                this.$GlobalStore.addModal('TrainingRequestDetail', { main_type: MAIN_TYPE.SOCCER_LEARN, isModalBackTransparent: true, isExpert: false, soccerhowIdx: soccerhowIdx })
                this.completeAction(isSave, soccerhowIdx)
            }
        }
    },

}
</script>

<style scoped>
.slide-card {
    width: 73%;
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: transform 0.3s ease, opacity 0.3s ease;
}

/* 중앙 슬라이드 확대 효과 */
.swiper-slide-active {
    transform: scale(1);
}

.swiper-slide-next,
.swiper-slide-prev {
    transform: scale(0.76);
}

.title {
    /* text-shadow: 0px 2.64px 13.22px #210F03; */
    text-align: center;
    font-weight: 700;
    font-size: 20px;
    line-height: 32px;
}

.sub_title {
    font-weight: 500;
    font-size: 14px;
    line-height: 32px;
    margin-bottom: 16px;
    text-align: center;
}

.card {
    position: relative;
    width: 100%;
    border-radius: 24px;
    /* background: linear-gradient(209.78deg, #FF8B3D 1.35%, #FCC583 47.37%, #FCD4B9 100.03%); */
    min-height: 342px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.un_active_overlay {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #210F0394;
    backdrop-filter: blur(3px);
    z-index: 10;
}
.card_img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
}

.card_contents {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    position: relative;
    z-index: 2;
    text-align: center;
    padding-bottom: 15px;
    align-items: center;
}

.card_theme {
    flex: 0 0 auto;
    padding: 0 10px;
    line-height: 24px;
    font-size: 12px;
    color: #fff;
    border-radius: 12px;
}

.card_title {
    margin-top: 5px;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
}

.card_text {
    margin-top: 5px;
    font-size: 14px;
    line-height: 24px;
}

.swiper-pagination>>>.swiper-pagination-bullet {
    width: 6px;
    height: 6px;
    background: #bbb;
    opacity: 1;
}

.swiper-pagination>>>.swiper-pagination-bullet-active {
    background: var(--color-main);
    width: 21px;
    height: 6px;
    border-radius: 8px;
}

.make_feed_btn {
    width: calc(100% - 48px);
    height: 56px;
    background-color: #fff;
    border-radius: 12px;
    font-weight: 700;
    line-height: 56px;
    text-align: center;
    margin: 0 auto;
}

</style>